// src/constants.ts
export const NAVIGATE_MAPPING_ALARM: Record<string, { goal: string }> = {
  '택배 발송이 곧 마감돼요': {
    goal: '/orders/order-details?orderTab=ready-to-ship',
  },

  '판매몰 신규 리뷰': {
    goal: '/orders/reviews?ctab=whole',
  },
  '상품 순위 모니터링': {
    goal: '/monitoring',
  },

  '뉴스 브리핑': {
    goal: '/dashboard',
  },
  '판매 돌파!': {
    goal: '/statistics',
  },
  '판매몰 신규 알림': {
    goal: '/orders/order-details?orderTab=new-order',
  },
  '문의사항 답변드려요': {
    goal: '/more?ctab=support&chistory=true',
  },
  '마켓 연동 안내': {
    goal: '/market',
  },
  '일일 보고드려요': {
    goal: '/statistics',
  },
  '문의 처리 지연': {
    goal: '/orders/inquiries?ctab=not-yet',
  },
  '지난달 보고드려요': {
    goal: '/statistics',
  },
};
